import React from 'react';
import { t } from 'Locale';
import { Modal } from 'react-native';
import { ConfirmationModal } from 'LocalGluons/components/ConfirmationModal';
import { popUpDefaultProps, popUpPropTypes } from '../../propTypes';

const PopUpDefault = ({ visible, title, confirmLabel, onConfirm }) => (
    <Modal transparent visible={visible} onRequestClose={onConfirm}>
        <ConfirmationModal
            header={t('COMMON.INFO')}
            message={title}
            confirmLabel={confirmLabel}
            onConfirm={onConfirm}
            onClose={onConfirm}
        />
    </Modal>
);

PopUpDefault.defaultProps = popUpDefaultProps;

PopUpDefault.propTypes = popUpPropTypes;

export default PopUpDefault;
